import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import PropTypes from "prop-types";
import {
  Typography,
  Grid,
  useTheme,
  TextField,
  Button,
  IconButton,
  useMediaQuery,
  Tooltip,
} from "@material-ui/core";
import CancelIcon from "@material-ui/icons/Cancel";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Autocomplete } from '@material-ui/lab';

require("dotenv").config();
const Create = ({ setDailog }) => {
  const roomType = ["Audio", "Video-VAS", "Video-CPV-6-split", "Video-CPV-4-split", "Video-CPV-Auto-split", "Video-CPV-DHL"]
  const methods = ["POST", "GET"]
  const statusCallbackevents = ["START", "END", "JOIN", "LEAVE"]
  const theme = useTheme();
  const isMatch = useMediaQuery(theme.breakpoints.down("xs"));
  const [createConference, setcreateConference] = useState({
    CallerId: localStorage.getItem("callerId"),
  });
  const [selected,setSelected] = useState("")
  const [, setData] = useState("");

  const handleConfChange = (e) => {
    setcreateConference({
      ...createConference,
      [e.target.name]: e.target.value,
    });
  };

  function ClearResponse() {
    setData("");
  }

  function makeCallAPI(event) {
    const updatedUrl = localStorage.getItem("apiEndpoint");
    const baseURL = updatedUrl?.length
      ? updatedUrl
      : window.config.apiEndpoint;
    ClearResponse();
    const headers = {
      "Content-Type": "application/json",
      apikey: localStorage.getItem("apikey") || window.config.apikey,
    };
    const acId = localStorage.getItem("accountId") || window.config?.accountId;
    const requestBody =selected?.length? {
      ...createConference,
      StatusCallbackEvent:selected.toString()
    }:{ ...createConference,};
    try {
      axios
        .post(`${baseURL}/accounts/${acId}/room`, requestBody, {
          headers: headers,
        })
        .then(function (response) {
          console.log(response);
          setData(JSON.stringify(response));
          toast.success("Room Created");
          setDailog(false);
        })
        .catch(function (error) {
          console.log(error);
          toast.error("Failed, StatusCode:" + error?.response?.data?.message);
        });
    } catch (error) {
      console.log("error", error);
    }
  }

  const handleEventChange=(e,selected)=>{
   console.log("multiselect",selected)
   setSelected(selected)
  }
console.log("selected",selected)
  return (
    <div style={isMatch ? { width: "300px" } : { width: "400px" }}>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        xs={12}
        md={12}
        lg={12}
        style={{
          textAlign: "center",
          borderBlockColor: "black",
          margin: "auto",
        }}
      >
        <Grid
          xs={12}
          md={12}
          lg={12}
          container
          style={{ backgroundColor: "#3f51b5", height: "65px" }}
        >
          <Grid xs={10} md={10} lg={10} item style={{}}>
            <Typography
              style={{
                marginTop: "3vh",
                fontWeight: "bold",
                color: "#ffffff",
                fontSize: "19px",
                marginBottom: "2vh",
                textAlign: "center",
              }}
            >
              Create Room
            </Typography>
          </Grid>
          <Grid xs={2} md={2} lg={2} item>
            <IconButton
              style={{ marginTop: "13%" }}
              onClick={() => {
                setDailog(false);
              }}
            >
              <CancelIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Grid
          xs={12}
          md={12}
          lg={12}
          item
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: "center",
            margin: "auto",
          }}
        >
          <Grid item xs={12} md={12} lg={12}>
            <TextField
              style={{ width: "90%" }}
              value={createConference?.RoomName}
              size="large"
              name="RoomName"
              margin="dense"
              variant="outlined"
              label={`Enter Room Name*`}
              onChange={handleConfChange}
            />
          </Grid>
        </Grid>
        <Grid
          container
          xs={12}
          md={12}
          lg={12}
          // container
          style={{
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "10px",
          }}
        >
          <Accordion style={{ width: "100%" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>Advanced Settings</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <div style={{ width: "100%" }}>
                <div style={{ display: "flex" }}>
                  <TextField
                    style={{ width: "100%", textAlign: "left" }}
                    outlined
                    fullwidth
                    select
                    maxRows={3}
                    minRows={3}
                    value={createConference?.RoomType}
                    name="RoomType"
                    size="large"
                    defaultValue={roomType[0]}
                    margin="dense"
                    variant="outlined"
                    label={`Select Roomtype`}
                    // placeholder={`Enter ${props.PlaceholderName1}`}
                    onChange={handleConfChange}
                    inputProps={{ style: { textAlign: "left" } }}
                  >
                    <option disabled>Select RoomType</option>
                    {roomType.map((item) => (
                      <option value={item} key={item}>
                        {item}
                      </option>
                    ))}
                  </TextField>
                  <Tooltip
                    title={
                      <div style={{ whiteSpace: "pre-line" }}>
                        {
                          "Supported room types are as follows\n - Audio: for audio conference\n - Video-VAS: For video conference\n - Video-CPV-6-split (6-Split static)\n - Video-CPV-4-split (4-Split static)\n - Video-CPV-Auto-split (Active Spreake)\n - Video-CPV-DHL (Dynamic Hangout)"
                        }
                      </div>
                    }
                  >
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div style={{ display: "flex", width: "100%" }}>
                  <TextField
                    style={{ width: "100%" }}
                    outlined
                    maxRows={3}
                    minRows={3}
                    value={createConference?.CallerId}
                    name="CallerId"
                    size="large"
                    margin="dense"
                    variant="outlined"
                    label={`Enter Caller Id`}
                    // placeholder={`Enter ${props.PlaceholderName1}`}
                    onChange={handleConfChange}
                  />
                  <Tooltip
                    title={
                      "This is tenant owned phone number used as caller ID, while inviting participant to join the room"
                    }
                  >
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div style={{ display: "flex" }}>
                  <TextField
                    outlined
                    style={{ width: "100%" }}
                    maxRows={3}
                    minRows={3}
                    value={createConference?.DialInPhone}
                    size="large"
                    margin="dense"
                    name="DialInPhone"
                    variant="outlined"
                    label={`Enter DialInPhone`}
                    // placeholder={`Enter ${props.PlaceholderName1}`}
                    onChange={handleConfChange}
                  />
                  <Tooltip
                    title={
                      "This is tenant owned phone number, to be used by PSTN / Mobile dial-in users"
                    }
                  >
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div style={{ display: "flex" }}>
                  <TextField
                    outlined
                    style={{ width: "100%", textAlign: "left" }}
                    maxRows={3}
                    minRows={3}
                    select
                    value={createConference?.GenerateDialInCode}
                    defaultValue="No"
                    name="GenerateDialInCode"
                    size="large"
                    margin="dense"
                    variant="outlined"
                    label={`Select GenerateDialInCode`}
                    // placeholder={`Enter ${props.PlaceholderName1}`}
                    onChange={handleConfChange}
                  >
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </TextField>
                  <Tooltip title={"Set to Yes, if PSTN dial-in required"}>
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
                {/* <TextField
                  outlined
                  style={{ width: "100%" }}
                  maxRows={3}
                  minRows={3}
                  value={createConference?.StatusCallbackEvent}
                  name="StatusCallbackEvent"
                  size="large"
                  margin="dense"
                  variant="outlined"
                  label={`Enter StatusCallbackEvent`}
                  // placeholder={`Enter ${props.PlaceholderName1}`}
                  onChange={handleConfChange}
                /> */}
                <div style={{ display: "flex", width: "100%" }}>
                  <Autocomplete
                    // style={{width:"100%"}}
                    multiple
                    id="tags-outlined"
                    style={{
                      paddingTop: "5px",
                      paddingBottom: "5px",
                      width: "100%",
                    }}
                    options={statusCallbackevents}
                    getOptionLabel={(option) => option}
                    inputProps={{ style: { height: "10px" } }}
                    // defaultValue={[r[13]]}
                    value={createConference?.StatusCallbackEvent}
                    onChange={(e, selected) => handleEventChange(e, selected)}
                    filterSelectedOptions
                    renderInput={(params) => (
                      <TextField
                        inputProps={{ style: { fontSize: "10px" } }}
                        {...params}
                        name="StatusCallbackEvent"
                        variant="outlined"
                        label="Select StatusCallbackEvent"
                        placeholder="Select StatusCallbackEvent"
                      />
                    )}
                  />
                  <Tooltip title={"Status call back event supported by room"}>
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div style={{ display: "flex" }}>
                  <TextField
                    outlined
                    style={{ width: "100%", textAlign: "left" }}
                    maxRows={3}
                    minRows={3}
                    value={createConference?.Method}
                    defaultValue={methods[0]}
                    name="Method"
                    size="large"
                    margin="dense"
                    variant="outlined"
                    select
                    label={`Select Method`}
                    // placeholder={`Enter ${props.PlaceholderName1}`}
                    onChange={handleConfChange}
                  >
                    <option disabled>Select Method</option>
                    {methods.map((item) => (
                      <option value={item} key={item}>
                        {item}
                      </option>
                    ))}
                  </TextField>
                  <Tooltip title={"Method type"}>
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
                <div style={{ display: "flex" }}>
                  <TextField
                    outlined
                    style={{ width: "100%" }}
                    maxRows={3}
                    minRows={3}
                    value={createConference?.StatusCallbackUrl}
                    name="StatusCallbackUrl"
                    size="large"
                    margin="dense"
                    variant="outlined"
                    label={`Enter StatusCallbackUrl`}
                    // placeholder={`Enter ${props.PlaceholderName1}`}
                    onChange={handleConfChange}
                  />
                  <Tooltip title={"It can be relative or absolute url"}>
                    <img
                      src="icons8-info.svg"
                      style={{
                        marginTop: "18px",
                        marginLeft: "5px",
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </Tooltip>
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <Grid
          xs={12}
          md={7}
          lg={7}
          item
          style={{
            marginBottom: "5vh",
            marginTop: "2vh",
            justifyContent: "center",
            textAlign: "center",
            margin: "auto",
          }}
        >
          <Button
            data-testid="button"
            onClick={makeCallAPI}
            disabled={!createConference?.RoomName?.length}
            style={{
              //   background: state.identity === "" ? "lightgrey" : "#314B9F",
              width: "100px",
              height: "34px",
              justifyContent: "center",
              textAlign: "center",
              margin: "auto",
              marginTop: "3vh",
              marginBottom: "3vh",
            }}
            variant="contained"
            size="small"
            color="primary"
          >
            Create
          </Button>
        </Grid>
      </Grid>
    </div>
  );
};
Create.propTypes = {
  setDailog: PropTypes.any,
};
export default withRouter(Create);
